<div *ngIf="canActivateAutoOrder === true; else autoOrderAlreadyActive" class="card px-3 py-1">
  <div class="d-flex flex-column">
    <div class="d-flex align-items-center justify-content-between">
      <div class="d-flex flex-column">
        <span class="bold text-dark">{{ 'HISTORY.AUTO_ORDER.TITLE' | translate }}</span>
        <span class="small text-dark">
        {{ 'HISTORY.AUTO_ORDER.SUBTITLE' | translate }}
          <span class="bold">{{ benefitName }}</span>
      </span>
      </div>
      <div class="form-group mb-0" style="min-width: 30%">
        <ng-select [(ngModel)]="autoOrderState"
                   (ngModelChange)="emitAutoOrderSettings()"
                   [items]="stateOptions"
                   bindValue="value"
                   [searchable]="false"
                   [clearable]="false"
                   id="autoOrderSummaryStateSelect"
                   [attr.aria-label]="'autoOrderSummaryStateSelect'"
                   appNgSelectAriaControl>
          <ng-template ng-label-tmp let-item="item">
            {{ item.label | translate }}
          </ng-template>

          <ng-template ng-option-tmp let-item="item">
            {{ item.label | translate }}
          </ng-template>
        </ng-select>
      </div>
    </div>
    <div class="d-flex flex-column" *ngIf="autoOrderState === AutoOrderState.Active">
      <hr class="w-100"/>
      <div class="d-flex align-items-center justify-content-between mt-1">
        <span>{{ 'HISTORY.AUTO_ORDER.MAX_NR_ORDER' | translate }}</span>
        <div class="custom-control custom-control-primary custom-switch justify-content-end">
          <input type="checkbox" [(ngModel)]="hasDynamicQuantity"
                 (ngModelChange)="emitAutoOrderSettings()"
                 class="custom-control-input"
                 id="hasDynamicQuantitySwitch" aria-label="toggleState"/>
          <label class="custom-control-label pl-3" id="hasDynamicQuantitySwitchLabel"
                 for="hasDynamicQuantitySwitch"></label>
        </div>
      </div>
      <span class="mt-1 bold text-dark"
            *ngIf="hasDynamicQuantity">{{ 'HISTORY.AUTO_ORDER.DYNAMIC_QUANTITY_INFO' | translate }}</span>
      <div class="mt-1 d-flex align-items-center justify-content-between"
           *ngIf="!hasDynamicQuantity">
        <span>{{ 'HISTORY.AUTO_ORDER.STRICT_NR_ORDER' | translate }}</span>
        <span>{{ fixedQuantity }}</span>
      </div>
    </div>
    <hr class="w-100"/>
    <span *ngIf="autoOrderState === AutoOrderState.Active; else inactiveMessage;"
          [innerHTML]="'HISTORY.AUTO_ORDER.ACTIVE_INFO' | translate"></span>
    <ng-template #inactiveMessage>
      <span [innerHTML]="'HISTORY.AUTO_ORDER.INACTIVE_INFO' | translate"></span>
    </ng-template>
  </div>
</div>
<ng-template #autoOrderAlreadyActive>
  <div *ngIf="canActivateAutoOrder === false" class="card" style="padding: 16px 32px 24px">
    <span>{{ 'AUTO_ORDER.BENEFIT_SUMMARY.ALREADY_ACTIVE' | translate }}</span>
    <span>
      {{ 'AUTO_ORDER.BENEFIT_SUMMARY.MORE_DETAILS' | translate }}
      <a class="a-primary" (click)="navigateToPage('/' + subdomain + '/benefit-details/auto-order/' + autoOrder.id)">
        {{ 'AUTO_ORDER.BENEFIT_SUMMARY.MORE_DETAILS_HERE' | translate }}
      </a>.
    </span>
  </div>
</ng-template>
